import { doc, serverTimestamp, updateDoc } from "firebase/firestore";
import { db } from '../../firebase';
import { buildUserSearchIndex } from '../userSearch';

export const handleUpdate = async (userDoc) => {
    const targetUserDocId = userDoc.id || userDoc.uid;
    if (!targetUserDocId) {
        throw new Error('Unable to save user changes because the user document id is missing.');
    }

    const q = doc(db, "users", targetUserDocId);
    const { id, ...userDocPayload } = userDoc;

    try {
        await updateDoc(q, {
            ...userDocPayload,
            ...buildUserSearchIndex(userDocPayload),
            updatedTime: serverTimestamp(),
        });
        console.log('User Updated!');
        alert('Profile Updated!');
        return true;
    }
    catch (error) {
        const errorMessage = error?.message || 'Unable to update this user.';
        alert(errorMessage);
        throw error;
    }
};
